import { render, staticRenderFns } from "./property-charge.vue?vue&type=template&id=644aafb3&scoped=true&"
import script from "./property-charge.vue?vue&type=script&lang=js&"
export * from "./property-charge.vue?vue&type=script&lang=js&"
import style0 from "./property-charge.vue?vue&type=style&index=0&id=644aafb3&lang=scss&scoped=true&"
import style1 from "./property-charge.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644aafb3",
  null
  
)

export default component.exports